import React from 'react'

import { withRouter } from 'react-router-dom'
import { AuthContext } from '../../main/ProvedorAutenticacao'
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import Upload from '../../componentes/Upload/Index';
import FileList from '../../componentes/FileList';
import { Calendar } from 'primereact/calendar'
import { Dropdown } from 'primereact/dropdown';
import { uniqueId } from "lodash";
import filesize from 'filesize';
import { MultiSelect } from 'primereact/multiselect'
import { InputMask } from 'primereact/inputmask';

import NavBar from '../../componentes/Navbar'
import CentralService from '../../app/service/CentralService'
import AtividadeService from '../../app/service/AtividadeService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import UsuarioGrupoTrabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import StatusAtividadeService from '../../app/service/StatusAtividadeService'

import './central.css'

class CentralAtividades extends React.Component {
  constructor(props) {
    super(props);

    this.centralService = new CentralService();
    this.atividadeService = new AtividadeService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTrabalhoService();
    this.statusAtividadeService = new StatusAtividadeService();

    this.acoesAtividade = this.acoesAtividade.bind(this);
    this.acoesDescricao = this.acoesDescricao.bind(this);
    this.acoesData = this.acoesData.bind(this);
    this.renderFooterAtividade = this.renderFooterAtividade.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);

    this.state = {
      central: [],
      detail: '',
      dataInicial: '',
      dataFinal: '',
      selectNotificacoes: null,
      //Alterar Atividade
      atividade: null,
      codigo: '',
      titulo: '',
      descricao: '',
      dtLimite: '',
      dtFatal: '',
      tipo: '',
      status: '',
      hora: '',
      displayAtividade: false,
      displayProcesso: false,
      displayAtividade: false,
      displayProcesso: false,
      displayDescricao: false,
      tipoAtividade: null,
      grupos: [],
      selectGrupo: null,
      subGrupos: [],
      selectSubGrupo: null,
      responsaveis: [],
      responsavel: null,
      interessados: [],
      interessado: null,
      pesquisaProcesso: '',
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      processos: [],
      processo: null,
      bloqueiaGrupo: false,
      optionStatus: null,
      responsaveisLista: [],
      quantidadeResponsaveis: '',
      interessadosLista: [],
      quantidadeInteressados: '',
      statusAtividade: [],
      detail: '',
      processos: [],
      //Histórico
      historico: [],
      registroHistorico: null,
      displayHistorico: null,
      dsHistorico: '',
      displayHistoricoIncluir: false,
      visibleHistorico: false,
      //Arquivos Anexados
      exibirLinkAnexo: 'none',
      displayArquivosAnexados: false,
      upLoadFiles: [],
      nome: '',
      dsArquivo: '',
      arquivos: [],
      modalDescricaoArquivo: false,
      arquivo: null,
      arquivoCodigo: '',
      visibleExcluirArquivo: false,
    };
  }

  listarStatusAtividade = () => {
    this.statusAtividadeService.listarStatus()
      .then(response => {
        this.setState({statusAtividade: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Status de Atividade', detail:`${this.state.detail}`, life: 4000});
      });
  }

  consultarCentral = () => { 
    const usuarioLogado = this.context.usuarioAutenticado;

    //Data inicial
    var month = this.pad2(this.state.dataInicial.getMonth()+1);//months (0-11)
    var day = this.pad2(this.state.dataInicial.getDate());//day (1-31)
    var year= this.state.dataInicial.getFullYear();
    var dataInicial =  year+"-"+month+"-"+day;
    //Data final
    var month = this.pad2(this.state.dataFinal.getMonth()+1);//months (0-11)
    var day = this.pad2(this.state.dataFinal.getDate());//day (1-31)
    var year= this.state.dataFinal.getFullYear();
    var dataFinal =  year+"-"+month+"-"+day;

    this.centralService.consultarCentral(usuarioLogado.codigo, dataInicial, dataFinal)
      .then(response => {
        this.setState({central: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Central de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  lerNotificacao = async (rowData) => {
    const central = {
      codigo: rowData.codigo,
      status: 2
    }
    this.centralService.lerNotificacao(central)
      .then(response => {
        this.consultarCentral();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Central de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  marcarComoNaoLida = async () => {
    if(this.state.selectNotificacoes == null || this.state.selectNotificacoes == '') {
      this.toast.show({severity:'error', summary: 'Central de Atividades', detail:'Nenhuma notificação foi selecionada', life: 4000});
      return false;
    } 

    var alteracoes = 0;
    for(let i = 0; i < this.state.selectNotificacoes.length; i++) {
      if(this.state.selectNotificacoes[i].status == 2) {
        const central = {
          codigo: this.state.selectNotificacoes[i].codigo,
          status: 1 
        }

        await this.centralService.lerNotificacao(central)
          .then(response => {
            alteracoes++;
          }).catch(error => {
            this.toast.show({severity:'error', summary: 'Central de Atividades', detail:`${this.state.detail}`, life: 4000});
          })
      }
    }

    if(alteracoes > 0) {
      await this.consultarCentral();
      this.toast.show({severity:'success', summary: 'Central de Atividades', detail:'Operação realizada com sucesso', life: 4000});
    } else {
      this.toast.show({severity:'error', summary: 'Central de Atividades', detail:'Nenhuma alteração foi realizada', life: 4000});
    }

    this.refreshPage();
  }

  marcarComoLida = async () => {
    if(this.state.selectNotificacoes == null || this.state.selectNotificacoes == '') {
      this.toast.show({severity:'error', summary: 'Central de Atividades', detail:'Nenhuma notificação foi selecionada', life: 4000});
      return false;
    } 

    var alteracoes = 0;
    for(let i = 0; i < this.state.selectNotificacoes.length; i++) {
      if(this.state.selectNotificacoes[i].status == 1) {
        const central = {
          codigo: this.state.selectNotificacoes[i].codigo,
          status: 2 
        }

        await this.centralService.lerNotificacao(central)
          .then(response => {
            alteracoes++;
          }).catch(error => {
            this.toast.show({severity:'error', summary: 'Central de Atividades', detail:`${this.state.detail}`, life: 4000});
          })
      }
    }

    if(alteracoes > 0) {
      await this.consultarCentral();
      this.toast.show({severity:'success', summary: 'Central de Atividades', detail:'Operação realizada com sucesso', life: 4000});
    } else {
      this.toast.show({severity:'error', summary: 'Central de Atividades', detail:'Nenhuma alteração foi realizada', life: 4000});
    }

    this.refreshPage();
  }

  excluirNotificacoes = async () => {
    if(this.state.selectNotificacoes == null || this.state.selectNotificacoes == '') {
      this.toast.show({severity:'error', summary: 'Central de Atividades', detail:'Nenhuma notificação foi selecionada', life: 4000});
      return false;
    } 

    var codigos = [];
    for(let i = 0; i < this.state.selectNotificacoes.length; i++) {
      codigos.push(this.state.selectNotificacoes[i].codigo);
    }
    await this.centralService.excluirNotificacoes(codigos)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Central de Atividades', detail:'Notificação(s) excluída(s) com sucesso', life: 4000});
        this.consultarCentral();
      }).catch(error => {
        console.log(error);
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Central de Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesAtividade(rowData) {
    if(rowData.atividade != null) {
      return(
        <React.Fragment>
          <a className={rowData.naoLida} onClick={() => this.consultarAtividade(rowData)} style={{cursor: 'pointer'}}>{rowData.atividade.titulo}</a>
        </React.Fragment>
      );
    } else {
      return(
        <React.Fragment>
          
        </React.Fragment>
      );
    }
  }

  acoesDescricao(rowData) {
    return(
      <React.Fragment>
        <a onClick={() => this.lerNotificacao(rowData)} className={rowData.naoLida}>{rowData.descricao}</a>
      </React.Fragment>
    );
  }
    
  acoesData(rowData) {
    return(
      <React.Fragment>
        <a className={rowData.naoLida}>{rowData.dataRegistro}</a>
      </React.Fragment>
    );
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  async componentDidMount() {
    //Datas últimos trinsta dias
    var date = new Date();
    var primeiroDia = new Date(date.getFullYear(), date.getMonth(), 1);
    var ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    //Data inicial
    var month = this.pad2(primeiroDia.getMonth()+1);//months (0-11)
    var day = this.pad2(primeiroDia.getDate());//day (1-31)
    var year= primeiroDia.getFullYear();
    var dataInicial =  year+"-"+month+"-"+day;
    //Data final
    var month = this.pad2(ultimoDia.getMonth()+1);//months (0-11)
    var day = this.pad2(ultimoDia.getDate());//day (1-31)
    var year= ultimoDia.getFullYear();
    var dataFinal =  year+"-"+month+"-"+day;

    var dataInicial2 = new Date(dataInicial);
    dataInicial2.setDate(dataInicial2.getDate()+1)

    var dataFinal2 = new Date(dataFinal);
    dataFinal2.setDate(dataFinal2.getDate()+1)
    
    await this.setState({dataInicial: dataInicial2});
    await this.setState({dataFinal: dataFinal2});

    this.consultarCentral(dataInicial, dataFinal);
  }

  refreshPage = () => {
    window.location.reload();
  }

  //Atividade
  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Alterar" 
                    onClick={this.alterarAtividade}
                    className="p-button-primary p-button-text"/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexados')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  async abrirModalArquivosAnexos(name, position){
    await this.listarArquivosAtividade()
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  listarArquivosAtividade = async () => {
    await this.arquivoAtividadeService.listarArquivos(this.state.atividade.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
        console.log('Tamanho dos arquivos lista', response.data.length)
        if(response.data.length > 0) {
          this.setState({exibirLinkAnexo: 'block'});
        } else {
          this.setState({exibirLinkAnexo: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  alterarAtividade = async () => {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    if(this.state.titulo == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsaveisLista == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    if(this.state.dtLimite != '') {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.tipo == 'A') {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '') {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.titulo,
        tipo: this.state.tipo,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        processo: this.state.processo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.optionStatus.codigo,
        subGrupo: this.state.selectSubGrupo
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    await this.atividadeService.alterarAtividade(this.state.atividade.dtLimite,
      this.state.atividade.status, usuarioLogado.codigo, atividadeAlterar)
        .then(response => {
          this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
          this.fecharModalAtividade('displayAtividade');
        }).catch(error => {
          this.setState(error.response.data);
          this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
        });

    this.setState({openSpinner: false});
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  async consultarAtividade(rowData) {
    this.setState({openSpinner: true});
    await this.atividadeService.consultarAtividade(rowData.atividade.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({descricao: response.data.descricao});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({tipo: response.data.tipo});
        this.consultarGruposTrabalho();
        this.setState({selectSubGrupo: response.data.subGrupo});
        if(response.data.processo != null) {
          this.setState({processo: response.data.processo});
          this.setState({pesquisaProcesso: response.data.processo.nrCnj});
          this.setState({sizePesquisa: 'col-sm-10'});
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'block'
          }});
          this.setState({bloqueiaGrupo: true});
        } else {
          this.setState({sizePesquisa: 'col-sm-12'});
          this.setState({bloqueiaGrupo: false});
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'none'
          }});
          this.setState({pesquisaProcesso: ''});
        }
        var dataLimite = new Date(response.data.dtLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          dataFatal.setDate(dataFatal.getDate())
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
        this.listarStatusAtividade();
        this.setState({optionStatus: response.data.status})

        this.lerNotificacao(rowData);

        this.listarArquivosAtividade();

        this.consultarResponsaveis();
        this.consultarInteressados();
        this.abrirModalAtividadeAlterar('displayAtividade');

      }
    ).catch(error => {
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    });
    this.setState({openSpinner: false});
  }

  consultarResponsaveis = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'R')
      .then(response => {
        this.setState({responsaveisLista: response.data});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.listarResponsaveis(); 
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarInteressados = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'I')
      .then(response => {
        this.setState({interessadosLista: response.data});
        if(this.state.interessadosLista.length == 0) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.listarInteressados();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  abrirModalAtividadeAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
    this.consultarGruposTrabalho();
  }

  consultarGrupoTrabalhoPai = async (codigo) => {
    await this.grupoTrabalhoService.consultarGrupo(codigo)
      .then(response => {
        this.setState({selectGrupo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Grupo de Trabalho', life: 4000});
      })
  }

  consultarSubGrupos = async(codigo) => {
    await this.grupoTrabalhoService.listarSubGrupos(codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  consultarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.grupoTrabalhoService.listarGruposUsuario(usuarioLogado.codigo)
      .then(response => {
        this.setState({grupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      })
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  //Upload de Documentos
  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  updateFile = (id, data) => {
    this.setState({upLoadFiles: this.state.upLoadFiles.map(upLoadFile => {
      return id === upLoadFile.id ? { ...upLoadFile, ...data } : upLoadFile;
    })})
  }

  processar = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('atividade',upLoadFile.file, this.state.atividade.codigo) //Envia código do processo para criar diretório
    data.append('usuario', upLoadFile.file, usuarioLogado.codigo);
    await this.arquivoAtividadeService.incluirArquivo(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.listarArquivosAtividade();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  } 

  consultarArquivo = async (arquivo) => {
    await this.arquivoAtividadeService.consultarArquivo(arquivo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarArquivoDescricao(arquivo) {
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      dsArquivo: this.state.dsArquivo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosAtividade();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  async download (rowData){
    await this.consultarArquivo(rowData.codigo);
    await this.arquivoAtividadeService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.nome); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  }

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivoDescricao(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  excluirArquivo = async () => {
    this.setState({classeDiv: 'show'});
    await this.arquivoProcessoService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosProcesso(this.state.processo.codigo);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
        this.setState({classeDiv: 'hide'});
      })

      this.setState({classeDiv: 'hide'});
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
          <Button label="Cancelar" 
                  className="p-button-secondary p-button-text"
                  onClick={() => this.fecharModalCadastro(name)}/>
          &nbsp;
          <Button label="Alterar" 
                  className="p-button-primary p-button-text"
                  onClick={this.adicionarDescricao}/>
        </div>
    );
  }

  render() {
    const { upLoadFiles } = this.state;
    return(
      <>
        <NavBar />
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="pi pi-comments"></i>
                          <span> Central de Atividades</span>
                        </h3>  
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12">
                            <Button icon="pi pi-check" 
                                    className="p-button-rounded p-button-text" 
                                    aria-label="Submit" 
                                    title="Marcar como lida" 
                                    onClick={this.marcarComoLida}/>
                            <Button icon="pi pi-bookmark" 
                                    className="p-button-rounded p-button-secondary p-button-text" 
                                    aria-label="Bookmark" 
                                    title="Voltar como não lida" 
                                    onClick={this.marcarComoNaoLida}/>
                            <Button icon="pi pi-times" 
                                    className="p-button-rounded p-button-danger p-button-text" 
                                    aria-label="Cancel" 
                                    title="Excluir" 
                                    onClick={this.excluirNotificacoes}/>
                            &nbsp;
                            &nbsp;
                            <Calendar id="mask" 
                                      value={this.state.dataInicial} 
                                      onChange={(e) => this.setState({ dataInicial: e.value })} 
                                      locale="es"
                                      style={{width: '15%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Data Inicial"
                                      mask="99/99/9999"/>
                            &nbsp;
                            <Calendar id="mask" 
                                      value={this.state.dataFinal} 
                                      onChange={(e) => this.setState({ dataFinal: e.value })} 
                                      locale="es"
                                      style={{width: '15%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      placeholder="Data Final"
                                      mask="99/99/9999"/>
                            &nbsp;
                            &nbsp;
                            <Button style={{height: '32px'}} type="button" className="p-button-secondary p-button-text p-button-sm" 
                                onClick={this.consultarCentral}>
                            <i className="pi pi-filter"></i> &nbsp;&nbsp;Filtrar</Button>
                          </div>
                        </div>
                      </div>
                      <DataTable value={this.state.central}  paginator responsiveLayout="scroll"
                        selection={this.state.selectNotificacoes} onSelectionChange={(e) => this.setState({ selectNotificacoes: e.value })}
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        emptyMessage="Nenhum notificação"
                        currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}>
                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} exportable={false}></Column>
                        <Column body={this.acoesDescricao} exportable={false} style={{ minWidth: '8rem' }}header="Descrição"></Column>
                        <Column body={this.acoesAtividade} exportable={false} style={{ minWidth: '8rem' }}header="Atividade"></Column>
                        <Column body={this.acoesData} exportable={false} style={{ minWidth: '8rem' }}header="Data"></Column>
                      </DataTable>
                    </div>
                  </div>
                </div>
              </div>
            {/**Consultar Atividade */}
            <Dialog header="Atividade" autoComplete="nope"
                    visible={this.state.displayAtividade} 
                    footer={this.renderFooterAtividade('displayAtividade')} 
                    onHide={() => this.fecharModalAtividade('displayAtividade')}>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <InputText id="titulo" 
                                  style={{width: '100%', height: '32px'}}
                                  type="text" 
                                  autoComplete="nope"
                                  value={this.state.titulo}
                                  onChange={e => this.setState({titulo: e.target.value})}
                                  className="p-inputtext-sm p-d-block p-mb-1"
                                  placeholder="Título"/>
                    </div>
                  </div>
                </div>
                
                <div className="row">
                  <div className={this.state.sizePesquisa}>
                    <div className="form-group">
                      <InputText id="processo" style={{width: '100%', height: '32px'}}
                                type="text"
                                autoComplete="nope"
                                disabled={this.state.bloqueiaGrupo}
                                value={this.state.pesquisaProcesso}
                                onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
                                onChange={e => this.setState({pesquisaProcesso: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"
                                placeholder="Incluir Processo, Pesquise o processo por Pessoa, Pasta ou Número"/>
                    </div>
                  </div>
                  <span style={this.state.escondeBotalExcluirPesquisa}>
                    <div className="col-sm-1">
                      <div className="form-group">
                        <Button icon="pi pi-times" className="p-button-rounded p-button-text" 
                                onClick={this.excluirPesquisaProcesso}
                                tooltip="Retirar Processo"
                                tooltipOptions={{position: 'top'}} />
                      </div>
                    </div>
                  </span>
                </div>
                
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Dropdown value={this.state.selectGrupo} style={{width: '100%', height: '32px'}} 
                        options={this.state.grupos}
                        disabled={this.state.bloqueiaGrupo}
                        optionLabel="nome" 
                        filter showClear filterBy="nome"
                        onChange={this.onGrupoTrabalhoChange}
                        id="grupoTrabalho"
                        className="p-inputtext-sm p-d-block p-mb-1"
                        placeholder="Grupo de Trabalho"/>
                        <a className="linkCadGrupo" href="#">Incluir novo Grupo de Trabalho</a>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                      options={this.state.subGrupos} style={{width: '100%', height: '37px'}}
                      optionLabel="nome" 
                      emptyMessage=" "
                      filter showClear filterBy="nome"
                      onChange={this.onSubGrupoChange}
                      id="subGrupoTrabalho"
                      className="p-inputtext-sm p-d-block p-mb-1"
                      placeholder="Sub-Grupo de Trabalho"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="form-group">
                      <MultiSelect inputId="multiselect" 
                                    value={this.state.responsaveisLista} 
                                    options={this.state.responsaveis} 
                                    style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                    onChange={(e) => this.setState({ responsaveisLista: e.value })} 
                                    filter showClear filterBy="nome"
                                    optionLabel="nome" 
                                    placeholder="Responsáveis"/>
                      <label className="linkCadGrupo">{this.state.quantidadeResponsaveis}</label>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <MultiSelect inputId="multiselect" 
                                    value={this.state.interessadosLista} 
                                    options={this.state.responsaveis} 
                                    style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                    onChange={(e) => this.setState({ interessadosLista: e.value })}  
                                    filter showClear filterBy="nome"
                                    optionLabel="nome" 
                                    placeholder="Interssados"/>
                      <label className="linkCadGrupo">{this.state.quantidadeInteressados}</label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-3">
                    <div className="form-group">
                      <Calendar id="mask" 
                                value={this.state.dtLimite} 
                                onChange={(e) => this.setState({ dtLimite: e.value })} 
                                locale="es"
                                style={{width: '100%', height: '32px'}} 
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                placeholder="Data Limite"/>
                    </div>
                  </div>
                  <div className="col-sm-3">
                    <div className="form-group">
                    <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                type="text"
                                mask="99:99"
                                value={this.state.hora}
                                onChange={e => this.setState({hora: e.target.value})}
                                className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="form-group">
                      <Calendar id="mask" 
                                value={this.state.dtFatal} 
                                onChange={(e) => this.setState({ dtFatal: e.value })} 
                                locale="es"
                                style={{width: '100%', height: '32px'}} 
                                dateFormat="dd/mm/yy"
                                mask="99/99/9999"
                                placeholder="Prazo fatal"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <Dropdown value={this.state.optionStatus} style={{width: '100%', height: '32px'}} 
                      options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                      optionLabel="status" 
                      emptyMessage=" "
                      filter showClear filterBy="status"
                      onChange={this.onChangeStatusAtividade}
                      id="idStatusAtividade"
                      className="p-inputtext-sm p-d-block p-mb-1"/>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-5">
                    <div className="form-group">
                    <a className="linkCadGrupoHistorico cursor" onClick={() => this.abrirModalDescricao('displayDescricao')}>Descrição da Atividade</a>                 
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <a className="linkCadGrupoHistorico cursor" onClick={this.consultarHistorico}>Consultar Histórico</a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    </div>
                  </div>
                  <div className="col-sm-3" style={{display: `${this.state.exibirLinkAnexo}`}}>
                    <div className="form-group">
                      <a className="linkCadGrupoHistorico cursor" onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexados')}>
                      <i className="pi pi-paperclip"></i>
                      &nbsp;
                      Arquivos Anexados</a>
                    </div>
                  </div>
                </div>
            </Dialog>
            {/**Arquivos Anexados */}
            <Dialog header="Arquivos Anexados"
                    style={{ width: '40vw' }} 
                    visible={this.state.displayArquivosAnexados} 
                    footer={
                      <frameElement>
                        <Button label="Fechar" 
                                className="p-button-secondary p-button-text"
                                onClick={() => this.fecharModalAtividade('displayArquivosAnexados')}/>
                      </frameElement>
                      
                    } 
                    onHide={() => this.fecharModalAtividade('displayArquivosAnexados')}>
                
                <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">  
                        <div className="container">
                          
                          <Upload onUpload={this.handleUpload}/>
                          {!!upLoadFiles && (
                            <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                          )}
                        
                        </div>
                      </div>
                    </div>
                  </div>
                  <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                              emptyMessage="Nenhum Arquivo">
                    <Column field="arquivo" header="Arquivo"/>
                    <Column field="dsArquivo" header="Descrição"/>
                    <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                  </DataTable> 
              </Dialog>   
              {/**Adicionar descrição ao arquivo */}
              <Dialog header="Descrição do Arquivo"
                      visible={this.state.modalDescricaoArquivo} 
                      style={{ width: '40vw' }} 
                      footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                      onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <label htmlFor="descricaoArquivo">Descrição</label>
                        <InputText id="descricaoArquivo" 
                              type="text" 
                              style={{width: '100%', height: '37px'}} 
                              value={this.state.dsArquivo}
                              onChange={e => this.setState({dsArquivo: e.target.value})}
                              className="p-inputtext-sm p-d-block p-mb-1"/>
                      </div>
                    </div>
                  </div>
            </Dialog>
          </section>
        </div>
      </>
    )
  }
}

CentralAtividades.contextType = AuthContext;
export default withRouter (CentralAtividades)